import { MultilineTextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { usePropertyVariousUnitsDescription } from '../../../../../queries/PropertyFields/NonRentalCoreFields';

interface VariousUnitsDescriptionProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const VariousUnitsDescription: React.FC<VariousUnitsDescriptionProps> = ({
    propertyGuid,
    required = false,
    isReview = false,
}) => {
    const label = 'Describe the units';

    const [variousUnitsDescription, set_variousUnitsDescription] = usePropertyVariousUnitsDescription(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={variousUnitsDescription}
                />
            ) : (
                <MultilineTextBox
                    id='variousUnitsDescription'
                    value={variousUnitsDescription}
                    onChange={set_variousUnitsDescription}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
